export default __webpack_public_path__ + "static/media/blur6.6faff926.png";